import { checkIsAutomatedBrowser } from '@/bot-detection/checkIsAutomatedBrowser.ts';
import { getNinjaConfig } from '@/config/ninja.ts';
import { getRegionConfig, loadRegionConfig } from '@/config/region.ts';
import { NINJA_EVENTS } from '@/const/events';
import { initCookieStorage } from '@/cookies/cookieStorage.ts';
import { getLogger } from '@/logger';
import { dataLayer } from '@/ninja/dataLayer.ts';
import { startSession } from '@/ninja/sessionManager.ts';
import { TASK_PRIORITY, taskQueue } from '@/task-queue';
import { registerTrackers } from '@/trackers/register.ts';
import { ClickEvent } from '@/types/events.ts';

const logger = getLogger('startup');

export async function startNinja() {
  logger.debug('Starting Ninja on', `${import.meta.env.__GIT_BRANCH__}@${import.meta.env.__GIT_HASH__}`, import.meta.env.__GIT_TAG__);

  if (getNinjaConfig().environment !== 'test') {
    if (!navigator.cookieEnabled) {
      logger.debug('Cookies are disabled in the browser. Ninja will not start.');
      return;
    }

    document.cookie = 'test=1; path=/; domain=' + getNinjaConfig().cookieDomain;
    await new Promise(resolve => setTimeout(resolve, 100));

    if (document.cookie.indexOf('test=1') === -1) {
      logger.debug('Cookies are not saved correctly. Ninja will not start.');
      return;
    }
    document.cookie = 'test=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=' + getNinjaConfig().cookieDomain;
  }

  const config = await loadRegionConfig();
  await initCookieStorage();
  logger.debug('Loaded region config and cookie storage');

  if (getRegionConfig()?.custom?.[getNinjaConfig().siteUrl]) {
    logger.debug('siteUrl found in region config');

    startSession();

    dataLayer.init();
    taskQueue.enqueue({
      fn: async () => registerTrackers(),
      priority: TASK_PRIORITY.HIGHEST,
      taskId: 'registerTrackers',
    });
    // pre-calculate bot detection state
    taskQueue.enqueue({
      fn: async () => checkIsAutomatedBrowser(),
      priority: TASK_PRIORITY.HIGHEST,
      taskId: 'checkIsAutomatedBrowser',
    });
    if (config) {
      taskQueue.enqueue({
        fn: async () => {
          const e: ClickEvent = Object.assign(
            {},
            {
              trackEvent: [NINJA_EVENTS.FETCHING_MATRIX],
            }
          );
          dataLayer.push(e);
        },
        priority: TASK_PRIORITY.HIGHEST,
        taskId: 'trackFetchingMatrix',
      });
    }
    taskQueue.enqueue({
      fn: async () => dataLayer.processDataLayer(),
      priority: TASK_PRIORITY.HIGHEST,
      taskId: 'dataLayer.processDataLayer',
    });
  } else {
    logger.error('No site configuration found for the current site', getNinjaConfig().siteUrl);
  }
}
